import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import { App } from './App';
import { initObservability } from './lib/observability';
import './index.css';

initObservability();

const root = createRoot(document.getElementById('root')!);

root.render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<FallbackErrorScreen />}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);

function FallbackErrorScreen() {
  return (
    <div className="flex min-h-dvh items-center justify-center p-8 text-center">
      <div>
        <h1 className="mb-2 text-2xl font-semibold text-text-primary">
          Something went wrong.
        </h1>
        <p className="text-text-secondary">
          Reload the page to try again. If the problem persists, your session is
          stored locally and can be recovered.
        </p>
      </div>
    </div>
  );
}
